<template>
  <v-select
    v-if="accounts.length > 1"
    v-model="selectedAccounts"
    clearable
    hide-details
    :label="$t('home.accounts')"
    :items="accounts"
    multiple
    dense
    small-chips
    outlined
    style="max-width: 200px"
  />
</template>
<script>
  export default {
    name: 'SelectAccounts',
    computed: {
      accounts () {
        return this.$store.state.accounts.list
      },
      selectedAccounts: {
        get () {
          return this.$store.state.accounts.selected
        },
        set (value) {
          this.$store.commit('SET_SELECTED_ACCOUNT', value)
        },
      },
    },
  }
</script>
